<template>
  <v-app-bar app color="#FFBD00" dark>
    <div class="d-flex align-center">
      <router-link to="/">
        <v-img
          alt="VTSV"
          class="shrink mr-2"
          contain
          src="@/assets/logo-vtsv-2.jpg"
          transition="scale-transition"
          width="180"
          height="50"
        />
      </router-link>
    </div>
  </v-app-bar>
</template>

<script>
export default {
  name: "Header"
};
</script>
